import estoreCategories from "@/services/estore.categories";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    categories: []
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories.map(category => {
        return {
          value: category.uuid,
          text: category.name
        }
      });
    }
  },
  getters: {
    loading: state => state.loading,
    categories: state => state.categories
  },
  actions: {
    async getCategories({ commit }) {
      commit("SET_LOADING", true);
      try {
        const response = await estoreCategories.getCategories();
        commit("SET_CATEGORIES", response.list);
        commit("SET_ERRORS", null);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
        commit("SET_ERRORS", null);
      }
    }
  }
};
